import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/help/tutorials/user/app-usage")({
  component: APPUsage,
});

export default function APPUsage() {
    return (
        <div>
            <img className={"m-auto"} src="/img/tutorial/user_tutorial.jpg" alt="App Usage" width={800}
                height={600} />
        </div>
    )
}
